<template>
  <div class="flex flex-col w-full h-full justify-start items-start bg-white overflow-y-auto">
    <div class="w-full h-12 p-4 shadow-md ">
      <span class="text-large text-black text-bold font-600 mr-3">Layout5</span>
    </div>

    <div class="flex flex-col px-4 gap-4 mt-4 w-full items-center">
      <!-- 按钮等 -->
      <div class="flex flex-row w-full p-0 mb-4">
        <div class="flex flex-col p-4 text-start border border-gray-300 rounded-md flex-1">

          <span class="text-sm">Default</span>
          <el-date-picker v-model="value1" class="block mb-4" type="date" placeholder="Pick a day" />
          <div class="flex flex-row gap-2 mb-2">
            <el-button class="mb-4 w-32" :plain="true" @click="open">Show message</el-button>
            <el-button class="mb-4 w-32" :plain="true" @click="openVn">VNode</el-button>
            <el-button class="mb-4 " @click="openMessageBox">Click to open the Message Box</el-button>
            <el-button plain @click="open1"> Closes automatically </el-button>
            <el-button plain @click="open2"> Won't close automatically </el-button>
          </div>

          <div class="flex flex-row gap-2 mb-2">
            <el-badge :value="12" class="item">
              <el-button>comments</el-button>
            </el-badge>
            <el-badge :value="3" class="item">
              <el-button>replies</el-button>
            </el-badge>
            <el-badge :value="1" class="item" type="primary">
              <el-button>comments</el-button>
            </el-badge>
            <el-badge :value="2" class="item" type="warning">
              <el-button>replies</el-button>
            </el-badge>
            <el-badge :value="1" class="item" color="green">
              <el-button>custom background</el-button>
            </el-badge>
            <el-dropdown class="m-2 w-32" trigger="click">
              <span class="el-dropdown-link">
                Click Me
                <el-icon class="el-icon--right"><caret-bottom /></el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item class="clearfix">
                    comments
                    <el-badge class="mark" :value="12" />
                  </el-dropdown-item>
                  <el-dropdown-item class="clearfix">
                    replies
                    <el-badge class="mark" :value="3" />
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>

        </div>
        <div class="ml-4 block p-4 text-center border border-gray-300 rounded-md flex-1">
          <div class="block p-4 text-center border border-gray-300 rounded-md flex-1">
            <el-upload v-model:file-list="fileList" class="upload-demo"
              action="https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15" multiple :on-preview="handlePreview"
              :on-remove="handleRemove" :before-remove="beforeRemove" :limit="3" :on-exceed="handleExceed">
              <el-button type="primary">Click to upload</el-button>
              <template #tip>
                <div class="el-upload__tip">
                  jpg/png files with a size less than 500KB.
                </div>
              </template>
            </el-upload>
          </div>
        </div>
      </div>
      <!-- 表单 -->
      <div class="flex flex-row w-full p-0 flex-wrap mb-4">
        <div class="block p-4 text-center border border-gray-300 rounded-md flex-1">
          <el-form :model="form" label-width="auto" style="max-width: 600px">
            <el-form-item label="Activity name">
              <el-input v-model="form.name" />
            </el-form-item>
            <el-form-item label="Activity zone">
              <el-select v-model="form.region" placeholder="please select your zone">
                <el-option label="Zone one" value="shanghai" />
                <el-option label="Zone two" value="beijing" />
              </el-select>
            </el-form-item>
            <el-form-item label="Activity time">
              <el-col :span="11">
                <el-date-picker v-model="form.date1" type="date" placeholder="Pick a date" style="width: 100%" />
              </el-col>
              <el-col :span="2" class="text-center">
                <span class="text-gray-500">-</span>
              </el-col>
              <el-col :span="11">
                <el-time-picker v-model="form.date2" placeholder="Pick a time" style="width: 100%" />
              </el-col>
            </el-form-item>
            <el-form-item label="Instant delivery">
              <el-switch v-model="form.delivery" />
            </el-form-item>
            <el-form-item label="Activity type">
              <el-checkbox-group v-model="form.type">
                <el-checkbox value="Online activities" name="type">
                  Online activities
                </el-checkbox>
                <el-checkbox value="Promotion activities" name="type">
                  Promotion activities
                </el-checkbox>
                <el-checkbox value="Offline activities" name="type">
                  Offline activities
                </el-checkbox>
                <el-checkbox value="Simple brand exposure" name="type">
                  Simple brand exposure
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="Resources">
              <el-radio-group v-model="form.resource">
                <el-radio-button value="Sponsor">Sponsor</el-radio-button>
                <el-radio-button value="Venue">Venue</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="Activity form">
              <el-input v-model="form.desc" type="textarea" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">Create</el-button>
              <el-button>Cancel</el-button>
            </el-form-item>
          </el-form>
        </div>


        <div class="m-4 block w-full h-full flex-1">
          <div class="flex flex-col gap-2 border border-gray-300 rounded-md p-4">
            <div class="flex gap-2">
              <el-tag type="primary">Tag 1</el-tag>
              <el-tag type="success">Tag 2</el-tag>
              <el-tag type="info">Tag 3</el-tag>
              <el-tag type="warning">Tag 4</el-tag>
              <el-tag type="danger">Tag 5</el-tag>
            </div>



            <el-descriptions class="margin-top" title="With border" :column="3" border>

              <template #extra>
                <el-button type="primary">Operation</el-button>
              </template>
              <el-descriptions-item>
                <template #label>
                  <div class="cell-item">
                    <el-icon :style="iconStyle">
                      <user />
                    </el-icon>
                    Username
                  </div>
                </template>
                kooriookami
              </el-descriptions-item>
              <el-descriptions-item>
                <template #label>
                  <div class="cell-item">
                    <el-icon :style="iconStyle">
                      <iphone />
                    </el-icon>
                    Telephone
                  </div>
                </template>
                18100000000
              </el-descriptions-item>
              <el-descriptions-item>
                <template #label>
                  <div class="cell-item">
                    <el-icon :style="iconStyle">
                      <location />
                    </el-icon>
                    Place
                  </div>
                </template>
                Suzhou
              </el-descriptions-item>
              <el-descriptions-item>
                <template #label>
                  <div class="cell-item">
                    <el-icon :style="iconStyle">
                      <tickets />
                    </el-icon>
                    Remarks
                  </div>
                </template>
                <el-tag size="small">School</el-tag>
              </el-descriptions-item>
              <el-descriptions-item>
                <template #label>
                  <div class="cell-item">
                    <el-icon :style="iconStyle">
                      <office-building />
                    </el-icon>
                    Address
                  </div>
                </template>
                No.1188, Wuzhong Avenue, Wuzhong District, Suzhou, Jiangsu Province
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>

      </div>


    </div>


  </div>

</template>

<script lang="ts">
import { defineComponent, ref, reactive, h } from 'vue';
import { ElMessage, ElMessageBox, ElNotification, Action } from 'element-plus'
import type { UploadProps, UploadUserFile } from 'element-plus'
import {
  CaretBottom,
  User,
  Iphone,
  Location,
  Tickets,
  OfficeBuilding,
} from '@element-plus/icons-vue'

export default defineComponent({
  name: 'Layout5',
  components: {
    CaretBottom,
    User,
    Iphone,
    Location,
    Tickets,
    OfficeBuilding,
  },
  setup() {
    const value1 = ref('')
    const size = ref('large')
    const iconStyle = ref({ color: 'red' })
    const form = reactive({
      name: '',
      region: '',
      date1: '',
      date2: '',
      delivery: false,
      type: [],
      resource: '',
      desc: '',
    })

    const onSubmit = () => {
      console.log('submit!')
    }


    // https://element-plus.org/zh-CN/component/loading.html
    const open = () => {
      ElMessage('This is a message.')
    }

    const openVn = () => {
      ElMessage({
        message: h('p', { style: 'line-height: 1; font-size: 14px' }, [
          h('span', null, 'Message can be '),
          h('i', { style: 'color: teal' }, 'VNode'),
        ]),
      })
    }

    const openMessageBox = () => {
      ElMessageBox.alert('This is a message box.', 'Warning', {
        confirmButtonText: 'OK',
        callback: (action: Action) => {
          ElMessage.info(`click ${action}`)
        }
      })
    }
    const open1 = () => {
      ElNotification({
        title: 'Title',
        message: h('i', { style: 'color: teal' }, 'This is a reminder'),
      })
    }

    const open2 = () => {
      ElNotification({
        title: 'Prompt',
        message: 'This is a message that does not automatically close',
        duration: 0,
      })
    }


    const fileList = ref<UploadUserFile[]>([
      {
        name: 'element-plus-logo.svg',
        url: 'https://element-plus.org/images/element-plus-logo.svg',
      },
      {
        name: 'element-plus-logo2.svg',
        url: 'https://element-plus.org/images/element-plus-logo.svg',
      },
    ])

    const handleRemove: UploadProps['onRemove'] = (file, uploadFiles) => {
      console.log(file, uploadFiles)
    }

    const handlePreview: UploadProps['onPreview'] = (uploadFile) => {
      console.log(uploadFile)
    }

    const handleExceed: UploadProps['onExceed'] = (files, uploadFiles) => {
      ElMessage.warning(
        `The limit is 3, you selected ${files.length} files this time, add up to ${files.length + uploadFiles.length
        } totally`
      )
    }

    const beforeRemove: UploadProps['beforeRemove'] = (uploadFile) => {
      return ElMessageBox.confirm(
        `Cancel the transfer of ${uploadFile.name} ?`
      ).then(
        () => true,
        () => false
      )
    }

    const disabledDate = (time: Date) => {
      return time.getTime() > Date.now()
    }

    return {
      open,
      openVn,
      openMessageBox,
      open1,
      open2,
      disabledDate,
      value1,
      form,
      onSubmit,
      fileList,
      handleRemove,
      handlePreview,
      handleExceed,
      beforeRemove,
      size,
      iconStyle,
    }
  }
});
</script>